import { FC } from "react";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionValues from "components/SectionValues/SectionValues";
import SectionPartners from "components/SectionPartners/SectionPartners";
import SectionHeroAnimated from "./SectionHeroAnimated";
import { useTranslation } from "react-i18next";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const { t, ready } = useTranslation("translation");

  if (!ready) return null;

  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>{t("translation:about.title")} | TRIBYOU</title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHeroAnimated
          rightImg={"https://images.unsplash.com/photo-1540553016722-983e48a2cd10?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
          heading={t("translation:about.animatedHero.heading")}
          animatedWords={t("translation:about.animatedHero.animatedWords", {returnObjects: true})}
          btnText=""
          subHeading={t("translation:about.animatedHero.subHeading")}
        />

        <SectionHero
          rightImg={"https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
          heading={t("translation:about.whyTribYou.heading")}
          btnText=""
          subHeading={t("translation:about.whyTribYou.subHeading")}
        />
        <SectionSubscribe2 />
        <SectionHero
          rightImg={"https://images.unsplash.com/photo-1525026198548-4baa812f1183?q=80&w=3134&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
          heading={t("translation:about.origins.heading")}
          btnText=""
          subHeading={t("translation:about.origins.subHeading")}
        />
        
        <div className="relative py-16">
          <BackgroundSection />
          <SectionValues uniqueClassName="SectionValues_" />
        </div>

        <SectionHero
          rightImg={"https://images.unsplash.com/photo-1654355252504-42c1c9dd1fe0?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"}
          heading={t("translation:about.audience.heading")}
          btnText=""
          subHeading={t("translation:about.audience.subHeading")}
        />
        <SectionPartners />
        
      </div>
    </div>
  );
};

export default PageAbout;
